const STORAGE_KEY = 'ird:wishlist';

const dispatchUpdate = (handles) => {
  document.dispatchEvent(
    new CustomEvent('ird:wishlist:updated', {
      detail: { handles, count: handles.length },
    })
  );
};

export const getWishlist = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    const handles = stored ? JSON.parse(stored) : [];
    return Array.isArray(handles) ? handles.filter(Boolean) : [];
  } catch {
    return [];
  }
};

export const setWishlist = (handles) => {
  const unique = [...new Set(handles.filter(Boolean))];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
  dispatchUpdate(unique);
  return unique;
};

export const isInWishlist = (handle) => getWishlist().includes(handle);

export const toggleWishlist = (handle) => {
  if (!handle) return getWishlist();

  const list = getWishlist();
  const index = list.indexOf(handle);

  if (index >= 0) {
    list.splice(index, 1);
  } else {
    list.push(handle);
  }

  return setWishlist(list);
};

export const setHeaderWishlistCount = (count = 0) => {
  const safeCount = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;

  document.querySelectorAll('[js-header-wishlist-count-desktop]').forEach((el) => {
    if (safeCount <= 0) {
      el.hidden = true;
      el.textContent = '';
      return;
    }

    el.hidden = false;
    el.textContent = ` (${safeCount})`;
  });

  document.querySelectorAll('[js-header-wishlist-count-mobile]').forEach((el) => {
    if (safeCount <= 0) {
      el.textContent = '';
      el.hidden = true;
      return;
    }

    el.textContent = String(safeCount);
    el.hidden = false;
  });
};

export const refreshHeaderWishlistCount = () => {
  const count = getWishlist().length;
  setHeaderWishlistCount(count);
  return count;
};
